import React from 'react';
import './Skeleton.css';

export default function Skeleton({ width, height, variant = 'text', className = '' }) {
  const style = {
    width: width || '100%',
    height: height || (variant === 'text' ? '1em' : variant === 'circular' ? '40px' : '20px')
  };

  return (
    <div 
      className={`skeleton skeleton-${variant} ${className}`}
      style={style}
      aria-hidden="true"
    />
  );
}
